document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.ginput_container_radio').forEach((elem, ind) => {
    elem.setAttribute('role', 'radiogroup');
    elem.setAttribute('aria-label', elem.parentElement.querySelector('.gfield_label').innerText);
  });

  document.querySelectorAll('.ginput_container_checkbox').forEach((elem, ind) => {
    let fieldLabel = elem.parentElement.querySelector('.gfield_label');
    if (fieldLabel.innerText == '') {
      fieldLabel.remove();
    }
  })
});
